import { responsiveFontSizes, createTheme } from '@mui/material/styles';
import createCache from '@emotion/cache';
import { heIL } from '@mui/material/locale';
import { heIL as dateHeLI } from '@mui/x-date-pickers/locales';
import {
  commonCache,
  commonComponentsStyles,
  commonShape,
  commonTypography,
  dashboardPaletteChabadIsrael,
  mergeUiComponentsPreservingCommonInputBase
} from '@malash-office/theme';
import { uiComponentsThemeComponents } from '@malash-office/ui-components';

const baseTheme = createTheme(
  {
    direction: 'rtl',
    palette: dashboardPaletteChabadIsrael,
    typography: { ...commonTypography },
    shape: { ...commonShape },
    components: { ...commonComponentsStyles }
  },
  dateHeLI,
  heIL
);

/** Design-system MUI overrides; preserve `commonComponentsStyles` InputBase callback (see merge helper). */
export const theme = responsiveFontSizes(
  createTheme(baseTheme, {
    components: mergeUiComponentsPreservingCommonInputBase(uiComponentsThemeComponents(baseTheme))
  }),
  {
    variants: []
  }
);

export const cacheRtl = createCache({
  ...commonCache
});

declare module '@mui/material/styles' {
  interface Palette {
    formGray?: {
      dark: string;
    };
  }
  interface PaletteOptions {
    formGray?: {
      dark: string;
    };
  }
}
